import * as Yup from 'yup';
import { ERROR_MESSAGES } from "../constants";

export const showcaseSchema = Yup.object({
  linkFacebook: Yup.string().typeError(ERROR_MESSAGES.URL_INVALID),
  linkInstagram: Yup.string().typeError(ERROR_MESSAGES.URL_INVALID),
  linkWebSite: Yup.string().typeError(ERROR_MESSAGES.URL_INVALID),
  linkMarketplace: Yup.string().typeError(ERROR_MESSAGES.URL_INVALID),
  linkVideo: Yup.string().typeError(ERROR_MESSAGES.URL_INVALID)
})